const common = {
  brand: "USFansSheet",
  nav: {
    home: "Strona główna",
    shopGuide: "Poradnik zakupów",
    categories: "Kategorie",
    resources: "Zasoby",
    guides: "Poradniki",
    safety: "Bezpieczeństwo",
    faq: "FAQ",
  },
  languages: {
    en: "English",
    pl: "Polski",
    es: "Español",
    fr: "Français",
  },
  footer: {
    tagline: "Niezależne centrum zasobów z badaniami, poradnikami i wskazówkami dotyczącymi arkusza USFans.",
    navTitle: "Odkrywaj",
    categoriesTitle: "Kategorie",
    disclaimer: "USFansSheet.live to niezależne źródło informacji. Nie jest koniecznie powiązane z USFans, zarządzane przez nie ani przez nie popierane. Informacje mogą się zmieniać i należy je samodzielnie zweryfikować przed dokonaniem zakupu, płatności lub podjęciem decyzji dotyczącej konta.",
    rights: "Wszelkie prawa zastrzeżone.",
  },
};

export default common;